import React from 'react';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import Loading from '@pb/kit-component-loading';

import type {AccountShortInfo} from 'src/openapi/admin/models/AccountShortInfo';
import type {Error} from 'src/openapi/admin/models/Error';

type Props = {
    id: string,
    isLoading: boolean,
    accounts: AccountShortInfo[],
    error: Error | null,
    noResultsMessage?: string,
};

export const AccountsList = ({id, isLoading, accounts, error, noResultsMessage}: Props) => {
    if (isLoading) {
        return (
            <div id={id} className="pd-s">
                <Group><Loading type="ICON"/> Loading</Group>
            </div>
        );
    }

    if (accounts?.length) {
        return (
            <div id={id}>
                {accounts.map(account => (
                    <AutosuggestItem
                        key={account.accountId}
                        value={account}
                        caption={(
                            <EllipsisTextHint>
                                {account.accountName}
                            </EllipsisTextHint>
                        )}
                    />
                ))}
            </div>
        );
    }

    if (accounts && !accounts.length && !error) {
        return (
            <div id={id} className="pd-s">
                {noResultsMessage || 'No accounts found'}
            </div>
        );
    }

    if (error) {
        return (
            <div id={id} className="pd-s">
                {error.message}
            </div>
        );
    }

    return null;
};
